export const findPosition = (allTags, id) =>
  // 找到該標籤位置
  allTags.findIndex(item => item.contentful_id === id)

export const handleFilterOnChange = (
  allTags,
  position,
  checkedState,
  setCheckedState,
  setId
) => {
  const updatedCheckedState = checkedState.map((item, index) =>
    index === position ? !item : item
  )

  setCheckedState(updatedCheckedState)

  const newIdList = []

  updatedCheckedState.forEach((currentState, idx) => {
    if (currentState) {
      newIdList.push(allTags[idx].contentful_id)
    }
  })

  setId(newIdList)
}
